import { ACTIONPLANS_ACTIONS_USER_EXCHANGES_MODULE_NAME } from '@/store/modules/actionplans/constants';
import module from './module';
import plugins from './plugins';
import registerTypes from './types';

export default (store) => {
  const MODULE_NAME = ACTIONPLANS_ACTIONS_USER_EXCHANGES_MODULE_NAME;
  const MODULE_PATH = MODULE_NAME.join('/');

  store.registerModule(MODULE_NAME, module);

  plugins(store, MODULE_PATH);

  registerTypes(store);
};
